import React from "react";
import Figure from "./Figure";

const serializers = {
  types: {
    authorReference: ({ node }) => <span>{node.author.name}</span>,
    mainImage: Figure,
    fileAsset: ({ node }) => {
      return (
        <a href={node.asset.url} target="_blank" download>
          {node.caption}
        </a>
      );
    }
  }
};

export default serializers;
